<script>
  import { onMount } from 'svelte';
  import trackView from '../events/trackView';
  import ProductCardsList from './ProductCardsList.svelte';
  import ajaxFetch from '../services/ajaxFetch.js';
  import Bundle from './Bundle.svelte';
  import SheetButton from './SheetButton.svelte';
  import trackHypothetical from '../events/trackHypothetical.js';

  /**
 *
 *
 *
 *
 */

  /*                */
  let { variationId, featureIndex, eventMergeId } = $props();

  let headline = $state();
  let pdpCardHasLoaded = $state(false);
  let recommendations = $state();
  let tracking = $state();
  let additionalClickTracking = $state();
  let featuresState = $state();
  let mainVariation = $state();

  const pageName = 'DetailView';

  onMount(async () => {
    o_global.eventQBus.emit('ft6bcn.reco-aos-frontend.a2b-banner-close');
    const res = await ajaxFetch(`/reco-core/recommendations/aos/variations/${variationId}`);
    if (res.status === 204) {
      if (res.headers && res.headers.has('promo_AosAvailability')) {
        trackHypothetical(res.headers.get('promo_AosAvailability'));
      }
      return;
    }
    if (res.status !== 200) {
      return;
    }
    try {
      ({
        headline,
        mainVariation,
        recommendations,
        tracking,
        additionalClickTracking,
        featuresState
      } = await res.json());
    } catch {
      return;
    }
    pdpCardHasLoaded = true;
    trackView(
      tracking,
      recommendations
        .slice(0, 2)
        .map((/*                             */ recommendation) => recommendation.tracking),
      featureIndex,
      eventMergeId
    );
  });
</script>

{#if pdpCardHasLoaded && recommendations.length > 0}
  <div class="reco_aos_container" data-testid="reco_aos_container">
    <h2 class="reco_aos_title">{headline}</h2>
    {#if featuresState?.ALLOW_AOS_BUNDLES === true}
      <Bundle
        {variationId}
        {mainVariation}
        recommendations={recommendations.slice(0, 2)}
        {tracking}
        {additionalClickTracking}
        {featureIndex}
        {featuresState} />
    {:else}
      <div>
        <ProductCardsList
          recommendations={recommendations.slice(0, 2)}
          {featureIndex}
          widgetTracking={tracking}
          widgetAdditionalClickTracking={additionalClickTracking}
          {pageName}
          {featuresState} />
      </div>
      {#if recommendations.length > 2}
        <SheetButton
          sourceVariationId={variationId}
          {recommendations}
          widgetTracking={tracking}
          widgetAdditionalClickTracking={additionalClickTracking}
          {featuresState} />
      {/if}
    {/if}
  </div>
{/if}

<style lang="scss">
  .reco_aos_title {
    font: var(--oc-semantic-font-headline-100);
  }
</style>
